<!--
 * @Description: 发票
 * @Author: 山淑兰
 * @Date: 2019-11-14 15:40:29
 * @LastEditTime: 2020-07-02 14:28:55
 * @LastEditors: 山淑兰
 -->
<template>
  <div id="invoice">
    <Loading v-if="show"></Loading>
    <div class="invoice_container">
      <div class="electronicTicket-banner">
        <img :src="MeetingInfo.MobileBannerImage" alt/>
      </div>
      <h2 class="invoice_title">请填写正确发票信息</h2>
      <div class="invoice_content">
        <div id="form">
          <form action class="registrationContent-form">
            <div class="form-item">
              <div class="formItem-title">
                <i>发票类型</i>
                <span class="mustfill">*</span>
              </div>
              <van-icon
                name="arrow-down"
                color="#969799"
                class="downIcon"
                size="1.39rem"
              />
              <select
                v-model="formDatas.invtype"
                @change="changes(formDatas.invtype)"
              >
                <option value="0" :disabled="isdisabled">增值税普通发票</option>
                <option value="1" :disabled="isdisabled">增值税专用发票</option>
              </select>
            </div>
            <div class="form-item">
              <div class="formItem-title">
                <i>开票抬头</i>
                <span class="mustfill">*</span>
              </div>
              <input
                type="text"
                class="isreq"
                name
                placeholder="请输入开票抬头"
                v-model="formDatas.invtitle"
                :disabled="isdisabled"
              />
            </div>
            <div class="form-item">
              <div class="formItem-title">
                <i>纳税人识别号/统一社会信用代码</i>
                <span class="mustfill">*</span>
              </div>
              <input
                type="text"
                class="isreq"
                name
                placeholder="请输入纳税人识别号/统一社会信用代码"
                v-model="formDatas.invconder"
                :disabled="isdisabled"
              />
            </div>

            <div class="form-item">
              <div class="formItem-title">
                <i>银行账号</i>
                <span class="mustfill" v-if="fp2">*</span>
              </div>
              <input
                type="text"
                class="isreqinit"
                name
                placeholder="请输入银行账号"
                v-model="formDatas.invbanknum"
                :disabled="isdisabled"
              />
            </div>
            <div class="form-item">
              <div class="formItem-title">
                <i>开户银行名称</i>
                <span class="mustfill" v-if="fp2">*</span>
              </div>
              <input
                type="text"
                class="isreqinit"
                name
                placeholder="请输入开户行"
                v-model="formDatas.invbank"
                :disabled="isdisabled"
              />
            </div>

            <div class="form-item">
              <div class="formItem-title">
                <i>注册地址</i>
                <span class="mustfill" v-if="fp2">*</span>
              </div>
              <input
                type="text"
                class="isreqinit"
                name
                placeholder="请输入注册地址"
                v-model="formDatas.invaddress"
                :disabled="isdisabled"
              />
            </div>
            <div class="form-item" :disabled="isdisabled">
              <div class="formItem-title">
                <i>公司注册电话</i>
                <span class="mustfill" v-if="fp2&&formDatas.invtype==1">*</span>
              </div>
              <input
                type="text"
                class="zhuce"
                name
                placeholder="请输入注册电话"
                v-model="formDatas.invphone"
                :disabled="isdisabled"
              />
            </div>
            <div class="invoice-title">
              收票信息填写
            </div>
            <!-- <div class="form-item">
              <div class="formItem-title">
                <i>收件人姓名</i>
              </div>
              <input
                type="text"
                class="zhuce"
                name
                placeholder="请输入开票人姓名"
                v-model="formDatas.username"
                :disabled="isdisabled"
              />
            </div>
            <div class="form-item">
              <div class="formItem-title">
                <i>收件人手机号码</i>
              </div>
              <input
                type="text"
                class="zhuce"
                name
                placeholder="请输入手机号"
                v-model="formDatas.userphone"
                :disabled="isdisabled"
              />
            </div> -->
            <div class="form-item">
              <div class="formItem-title">
                <i>发票接收邮箱</i>
                <span class="mustfill">*</span>
              </div>
              <input
                type="text"
                class="zhuce"
                name
                placeholder="请输入接收邮箱"
                v-model="formDatas.mailingaddress"
                :disabled="isdisabled"
              />
            </div>
            <div class="submit" @click="getFormData">{{ btnMsg }}</div>
          </form>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import publicSignup from '../../lib/signUp.js'
import '../../sass/form.scss'
import Loading from '@components/Loading.vue'

export default {
  name: 'invoice',
  components: {
    Loading
  },
  data() {
    return {
      show: true,
      title: '',
      m: '',
      muid: '',
      publicTools: {}, //通用publicSignup
      MeetingInfo: {}, //会议基本信息
      MeetingUserInfo: {}, //获取当前登录账户报名信息接口
      formDatas: {}, //发票表单数据
      sentDtas: {}, //发送的表单数据
      isdisabled: false,
      btnMsg: '提交',
      isbtn: true,
      unSubmit: true,
      fNavShow: true,
      fp1: true,
      fp2: true
    }
  },

  created() {
    document.title = this.title
    this.m = this.$route.query.m

    this.publicTools = new publicSignup()
  },
  async mounted() {
    let opt = {
      m: this.m,
      ch: this.$route.query.ch,
    }

    this.MeetingInfo = await this.publicTools.init(opt, this)
    
    let res = await this.publicTools.GetSignMeetingUserByMu(opt, this)
    this.MeetingUserInfo = res
    this.muid = res.CurrMuid
    let params = {
      m: this.m,
      muid: this.MeetingUserInfo.CurrMuid,
    }
    this.init(params)
    // if (this.MeetingInfo.HomeUrl == null) {
    //   this.fNavShow = false
    // }
    // sessionStorage.setItem("HomeUrl",this.MeetingInfo.HomeUrl)
    // sessionStorage.setItem("isshowlogo",this.MeetingInfo.isshowlogo)
  },

  methods: {
    async init(params) {
      try {
        this.formDatas = await this.$http.InitSignUpInvoice(params)

        if (this.formDatas.Code === 1000) {
          this.show = false
          if (this.formDatas.invstatus !== 0) {
            this.isdisabled = true
            this.isbtn = false
            if (this.formDatas.invstatus === 1) {
              this.unSubmit = false
              this.btnMsg = '您已开票'
            }
          }
          this.changes(this.formDatas.invtype)
        } else {
          this.$notify({
            message: this.formDatas.Code + ',' + this.formDatas.Msg,
            type: 'danger',
            duration: '20000',
          })
        }
      } catch (err) {
        console.log(err)
      }
    },
    async getFormData() {
      let isnull = true
      let {
        invid,
        username,
        userphone,
        invtype,
        invtitle,
        invconder,
        invaddress,
        invphone,
        invbank,
        invbanknum,
        invmoney,
        mailingaddress,
      } = this.formDatas

      let sd = []
      sd.push(
        invid,
        username,
        userphone,
        invtype,
        invtitle,
        invconder,
        invaddress,
        invphone,
        invbank,
        invbanknum,
        invmoney,
        mailingaddress
      )
      console.log(sd, invtype)

      let inps = document.getElementsByClassName("isreq")
      for (let i = 0; i < inps.length; i++) {
        if (inps[i].value == false) {
          isnull = false
          this.$notify({
            message: '带*号项不能为空',
            type: 'danger',
          })
        }
      }
	  
	  var reg = /^[^\s@]+@([^\s@.,]+\.)+[^\s@.,]{2,}$/
	  let reEmail = reg.test(this.formDatas.mailingaddress)
	  if( !reEmail ){
		  this.$notify({
		    message: '请输入正确的邮箱',
		    type: 'danger',
		  })
		  return
	  }
	  
      if (this.isbtn && isnull && this.unSubmit) {
        let {
          invid,
          username,
          userphone,
          invtype,
          invtitle,
          invconder,
          invaddress,
          invphone,
          invbank,
          invbanknum,
          invmoney,
          mailingaddress,
        } = this.formDatas

        this.sentDtas = {
          invid,
          username,
          userphone,
          invtype,
          invtitle,
          invconder,
          invaddress,
          invphone,
          invbank,
          invbanknum,
          invmoney,
          mailingaddress,
          muid: this.muid,
          m: this.m,
        }

        try {
          let res = await this.$http.EditUserInvoice(this.sentDtas)
          console.log(res)
          if (res.Code === 1000) {
            this.$notify({
              message: '提交成功',
              type: 'success',
            })
          } else {
            this.$notify({
              message: '提交失败：' + res.Code + ',' + res.Msg,
              type: 'danger',
              duration: '20000',
            })
          }
        } catch (err) {
          console.log(err)
        }
      }
    },
    //匹配数字
    reNumber() {
      this.formDatas.userphone = this.formDatas.userphone.replace(/[^\d]/g, '')
    },
    //匹配手机号
    reNum(ev) {
      if (
        this.publicTools.regCheck(this.formDatas.userphone, 'tel', ev, this)
      ) {
        this.formDatas.userphone = ''
      }
    },
    changes(invtype) {
      let that = this
      if (invtype == 1) {
        that.fp2 = true
        let _inp = document.querySelectorAll('input')
        for (let i = 0; i < _inp.length; i++) {
          _inp[i].classList.add('isreq')
        }
        let _inps = document.getElementsByClassName('zhuce')
        for (let i = 0; i < _inps.length; i++) {
          _inps[i].classList.remove('isreq')
        }
      }else{
        that.fp2 = false
        let _inp = document.getElementsByClassName("isreqinit")
        for (let i = 0; i < _inp.length; i++) {
          _inp[i].classList.remove('isreq')
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#invoice {
  .invoice_container {
    padding-bottom: 120px;
    .electronicTicket-banner {
      > img {
        width: 100%;
      }
    }
    .invoice_title {
      font-size: 38px;
      text-align: center;
      height: 140px;
      line-height: 140px;
      color: #555;
    }
    .invoice_content {
      width: 93%;
      margin: 0 auto;
      background: #fff;
      padding: 16px;
      padding-bottom: 20px;
    }
    input:disabled {
      background: #f9f9f9;
    }
    .invoice-title{
      font-size: 30px;
      margin-bottom: 20px;
      color: red;
    }
  }
}
</style>
